import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Toggle from 'material-ui/Toggle';
import { FieldTitle } from 'admin-on-rest';

const styles = {
  cursor: 'pointer',
  position: 'absolute',
  overflow: 'visible',
  display: 'block',
  height: 'auto',
  width: '54px',
  top: '13px',
  right: '8px',
};

class BooleanInput extends Component {
    handleToggle = (event, value) => {
      this.props.input.onChange(value);
    };

    render() {
      const {
        input,
        isRequired,
        label,
        source,
        resource,
        options,
      } = this.props;

      return (
        <Toggle
          defaultToggled={!!input.value}
          onToggle={this.handleToggle}
          style={styles}
          label={
            <FieldTitle
              label={label}
              source={source}
              resource={resource}
              isRequired={isRequired}
            />
          }
          {...options}
        />
      );
    }
}

BooleanInput.propTypes = {
  addField: PropTypes.bool,
  elStyle: PropTypes.object,
  input: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  resource: PropTypes.string,
  source: PropTypes.string,
  options: PropTypes.object,
};

BooleanInput.defaultProps = {
  addField: true,
  options: {},
};

export default BooleanInput;
